// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/default-qr.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styleSelector_eXLPz {
  width: 100% !important;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 14px;
  box-sizing: border-box;
}

.label_GMDwy {
  display: block;
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 4px;
  text-align: left;
}

.selectedStyleDisplay_9Gx5P {
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 24px;
  text-align: left;
}
.selectedStyleLabel_iv5Y6 {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
  text-align: left;
}
.selectedStyleName_H2adf {
  font-size: 0.85rem;
  font-weight: 500;
  color: #666666;
  margin-bottom: 0;
  text-align: left;
}



.grid_TjIuv {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}

.styleItem_wWMj4 {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;
  text-align: center;
  background-color: var(--white-background);
  min-height: 80px;
  min-width: 120px;
  max-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  flex: 1 1;
}

.styleItem_wWMj4:hover {
  border-color: #b6b6b6;
  background-color: var(--f5-background);
  color: #333;
}

.styleItem_wWMj4.selected_DuPL4 {
  border-color: transparent;
  background-color: #EAEAEF;
  font-weight: 600;
}

.styleItem_wWMj4.selected_DuPL4 .styleName_mxLcv {
  color: #4F5660;
}

.previewPlaceholder_EOtXc {
  width: 55px;
  height: 55px;
  background-color: #f0f2f5;
  border-radius: 4px;
  margin: 0 auto 8px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  color: #aaa;
  border: 1px dashed #ccc;
}

.styleItem_wWMj4:nth-child(1) .previewPlaceholder_EOtXc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  border: none;
}
.styleItem_wWMj4:nth-child(2) .previewPlaceholder_EOtXc {
  background-image: radial-gradient(circle, #555 3px, transparent 3px);
  background-size: 10px 10px;
}
.styleItem_wWMj4:nth-child(7) .previewPlaceholder_EOtXc {
  background-color: var(--black-color);
  border: 1px solid #555;
  background-image: radial-gradient(circle, #0f0 3px, transparent 3px);
  background-size: 10px 10px;
}

.styleName_mxLcv {
  font-size: 0.8rem;
  color: #364153;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: auto;
}

.previewImage_rIGCV {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
}


@media (max-width: 1024px) {
  .grid_TjIuv {
    gap: 10px;
  }

  .styleItem_wWMj4 {
    min-width: 130px;
    max-width: 130px;
    min-height: 75px;
  }

  .previewPlaceholder_EOtXc {
    width: 50px;
    height: 50px;
  }

  .previewImage_rIGCV {
    width: 45px;
    height: 45px;
  }
}

@media (max-width: 768px) {
  .styleSelector_eXLPz {
    margin-bottom: 24px;
  }

  .selectedStyleDisplay_9Gx5P {
    margin-bottom: 16px;
  }

  .grid_TjIuv {
    display: grid;
    grid-template-columns: repeat(3, 1fr); 
    gap: 8px;
    align-items: stretch;
  }

  .styleItem_wWMj4 {
    min-width: 0;
    max-width: none;
    min-height: 70px;
    padding: 8px;
    gap: 6px;
    flex: none; 
  }

  .previewPlaceholder_EOtXc {
    width: 45px;
    height: 45px;
    margin: 0 auto 6px auto;
  }

  .previewImage_rIGCV {
    width: 40px;
    height: 40px;
  }

  .styleName_mxLcv {
    font-size: 0.75rem;
    white-space: normal; 
    overflow: visible;
    text-overflow: clip;
    line-height: 1.2;
  }
}

@media (max-width: 600px) {
  .grid_TjIuv {
    grid-template-columns: repeat(2, 1fr); 
    gap: 10px;
  }

  .styleItem_wWMj4 {
    min-height: 85px;
    padding: 10px 8px;
    gap: 8px;
  }

  .previewPlaceholder_EOtXc {
    width: 50px;
    height: 50px;
    margin: 0 auto 8px auto;
  }

  .previewImage_rIGCV {
    width: 45px;
    height: 45px;
  }

  .styleName_mxLcv {
    font-size: 0.8rem;
    text-align: center;
  }

  .selectedStyleLabel_iv5Y6 {
    font-size: 0.95rem;
    margin-bottom: 6px;
  }

  .selectedStyleName_H2adf {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .styleSelector_eXLPz {
    margin-bottom: 20px;
  }

  .selectedStyleDisplay_9Gx5P {
    margin-bottom: 12px;
  }

  .grid_TjIuv {
    gap: 8px;
  }

  .styleItem_wWMj4 {
    min-height: 75px;
    padding: 8px 6px;
    gap: 6px;
  }

  .previewPlaceholder_EOtXc {
    width: 40px;
    height: 40px;
    margin: 0 auto 6px auto;
  }

  .previewImage_rIGCV {
    width: 35px;
    height: 35px;
  }

  .styleName_mxLcv {
    font-size: 0.7rem;
    line-height: 1.1;
  }

  .selectedStyleLabel_iv5Y6 {
    font-size: 0.9rem;
    margin-bottom: 4px;
  }

  .selectedStyleName_H2adf {
    font-size: 0.75rem;
  }
}

@media (max-width: 375px) {
  .grid_TjIuv {
    gap: 6px;
  }

  .styleItem_wWMj4 {
    min-height: 70px;
    padding: 6px 4px;
    gap: 4px;
  }

  .previewPlaceholder_EOtXc {
    width: 35px;
    height: 35px;
    margin: 0 auto 4px auto;
  }

  .previewImage_rIGCV {
    width: 30px;
    height: 30px;
  }

  .styleName_mxLcv {
    font-size: 0.65rem;
    line-height: 1.0;
  }
}

@media (max-width: 320px) {
  .grid_TjIuv {
    grid-template-columns: 1fr; 
    gap: 8px;
  }

  .styleItem_wWMj4 {
    min-height: 60px;
    padding: 8px;
    gap: 8px;
    flex-direction: row; 
    text-align: left;
    justify-content: flex-start;
  }

  .previewPlaceholder_EOtXc {
    width: 40px;
    height: 40px;
    margin: 0 12px 0 0;
    flex-shrink: 0;
  }

  .previewImage_rIGCV {
    width: 35px;
    height: 35px;
  }

  .styleName_mxLcv {
    font-size: 0.8rem;
    margin-top: 0;
    text-align: left;
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/StyleSelector/StyleSelector.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf;8BAC4B;EAC5B,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yDAAoD;EACpD,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,oEAAoE;EACpE,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oEAAoE;EACpE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".styleSelector {\n  width: 100% !important;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 14px;\n  box-sizing: border-box;\n}\n\n.label {\n  display: block;\n  font-size: 0.8rem;\n  color: #888;\n  margin-bottom: 4px;\n  text-align: left;\n}\n\n.selectedStyleDisplay {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 24px;\n  text-align: left;\n}\n.selectedStyleLabel {\n  display: block;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #222222;\n  margin-bottom: 8px;\n  text-align: left;\n}\n.selectedStyleName {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #666666;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n\n\n.grid {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.styleItem {\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  padding: 10px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,\n    background-color 0.2s ease;\n  text-align: center;\n  background-color: var(--white-background);\n  min-height: 80px;\n  min-width: 120px;\n  max-width: 120px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  flex: 1;\n}\n\n.styleItem:hover {\n  border-color: #b6b6b6;\n  background-color: var(--f5-background);\n  color: #333;\n}\n\n.styleItem.selected {\n  border-color: transparent;\n  background-color: #EAEAEF;\n  font-weight: 600;\n}\n\n.styleItem.selected .styleName {\n  color: #4F5660;\n}\n\n.previewPlaceholder {\n  width: 55px;\n  height: 55px;\n  background-color: #f0f2f5;\n  border-radius: 4px;\n  margin: 0 auto 8px auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.7rem;\n  color: #aaa;\n  border: 1px dashed #ccc;\n}\n\n.styleItem:nth-child(1) .previewPlaceholder {\n  background-image: url('../../assets/default-qr.png');\n  background-size: contain;\n  border: none;\n}\n.styleItem:nth-child(2) .previewPlaceholder {\n  background-image: radial-gradient(circle, #555 3px, transparent 3px);\n  background-size: 10px 10px;\n}\n.styleItem:nth-child(7) .previewPlaceholder {\n  background-color: var(--black-color);\n  border: 1px solid #555;\n  background-image: radial-gradient(circle, #0f0 3px, transparent 3px);\n  background-size: 10px 10px;\n}\n\n.styleName {\n  font-size: 0.8rem;\n  color: #364153;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: auto;\n}\n\n.previewImage {\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n\n@media (max-width: 1024px) {\n  .grid {\n    gap: 10px;\n  }\n\n  .styleItem {\n    min-width: 130px;\n    max-width: 130px;\n    min-height: 75px;\n  }\n\n  .previewPlaceholder {\n    width: 50px;\n    height: 50px;\n  }\n\n  .previewImage {\n    width: 45px;\n    height: 45px;\n  }\n}\n\n@media (max-width: 768px) {\n  .styleSelector {\n    margin-bottom: 24px;\n  }\n\n  .selectedStyleDisplay {\n    margin-bottom: 16px;\n  }\n\n  .grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr); \n    gap: 8px;\n    align-items: stretch;\n  }\n\n  .styleItem {\n    min-width: 0;\n    max-width: none;\n    min-height: 70px;\n    padding: 8px;\n    gap: 6px;\n    flex: none; \n  }\n\n  .previewPlaceholder {\n    width: 45px;\n    height: 45px;\n    margin: 0 auto 6px auto;\n  }\n\n  .previewImage {\n    width: 40px;\n    height: 40px;\n  }\n\n  .styleName {\n    font-size: 0.75rem;\n    white-space: normal; \n    overflow: visible;\n    text-overflow: clip;\n    line-height: 1.2;\n  }\n}\n\n@media (max-width: 600px) {\n  .grid {\n    grid-template-columns: repeat(2, 1fr); \n    gap: 10px;\n  }\n\n  .styleItem {\n    min-height: 85px;\n    padding: 10px 8px;\n    gap: 8px;\n  }\n\n  .previewPlaceholder {\n    width: 50px;\n    height: 50px;\n    margin: 0 auto 8px auto;\n  }\n\n  .previewImage {\n    width: 45px;\n    height: 45px;\n  }\n\n  .styleName {\n    font-size: 0.8rem;\n    text-align: center;\n  }\n\n  .selectedStyleLabel {\n    font-size: 0.95rem;\n    margin-bottom: 6px;\n  }\n\n  .selectedStyleName {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .styleSelector {\n    margin-bottom: 20px;\n  }\n\n  .selectedStyleDisplay {\n    margin-bottom: 12px;\n  }\n\n  .grid {\n    gap: 8px;\n  }\n\n  .styleItem {\n    min-height: 75px;\n    padding: 8px 6px;\n    gap: 6px;\n  }\n\n  .previewPlaceholder {\n    width: 40px;\n    height: 40px;\n    margin: 0 auto 6px auto;\n  }\n\n  .previewImage {\n    width: 35px;\n    height: 35px;\n  }\n\n  .styleName {\n    font-size: 0.7rem;\n    line-height: 1.1;\n  }\n\n  .selectedStyleLabel {\n    font-size: 0.9rem;\n    margin-bottom: 4px;\n  }\n\n  .selectedStyleName {\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 375px) {\n  .grid {\n    gap: 6px;\n  }\n\n  .styleItem {\n    min-height: 70px;\n    padding: 6px 4px;\n    gap: 4px;\n  }\n\n  .previewPlaceholder {\n    width: 35px;\n    height: 35px;\n    margin: 0 auto 4px auto;\n  }\n\n  .previewImage {\n    width: 30px;\n    height: 30px;\n  }\n\n  .styleName {\n    font-size: 0.65rem;\n    line-height: 1.0;\n  }\n}\n\n@media (max-width: 320px) {\n  .grid {\n    grid-template-columns: 1fr; \n    gap: 8px;\n  }\n\n  .styleItem {\n    min-height: 60px;\n    padding: 8px;\n    gap: 8px;\n    flex-direction: row; \n    text-align: left;\n    justify-content: flex-start;\n  }\n\n  .previewPlaceholder {\n    width: 40px;\n    height: 40px;\n    margin: 0 12px 0 0;\n    flex-shrink: 0;\n  }\n\n  .previewImage {\n    width: 35px;\n    height: 35px;\n  }\n\n  .styleName {\n    font-size: 0.8rem;\n    margin-top: 0;\n    text-align: left;\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"styleSelector": `styleSelector_eXLPz`,
	"label": `label_GMDwy`,
	"selectedStyleDisplay": `selectedStyleDisplay_9Gx5P`,
	"selectedStyleLabel": `selectedStyleLabel_iv5Y6`,
	"selectedStyleName": `selectedStyleName_H2adf`,
	"grid": `grid_TjIuv`,
	"styleItem": `styleItem_wWMj4`,
	"selected": `selected_DuPL4`,
	"styleName": `styleName_mxLcv`,
	"previewPlaceholder": `previewPlaceholder_EOtXc`,
	"previewImage": `previewImage_rIGCV`
};
export default ___CSS_LOADER_EXPORT___;
